import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import qListObject from '../hooks/qListObject'
import Select from 'react-select'
import * as lodash from 'lodash'
const { xor } = lodash

const QDocSearch = ({ qDocPromise, cols, qPage, ignoreLock, single, afterSelect }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [value, setValue] = useState('')
  const [valueList, setValueList] = useState('')
  const node = useRef(null)

  const { beginSelections, endSelections, qData, select, searchListObjectFor, acceptListObjectSearch } = qListObject({
    qDocPromise,
    cols,
    qPage,
  })

  const _searchListObjectFor = event => {
    _acceptListObjectSearch()
    setValue(event.target.value)
    searchListObjectFor(event.target.value)
  }

  const clear = () => {
    setValue('')
    _searchListObjectFor('')
  }

  const toggle = event => {
    const outsideClick = event ? !node.current.contains(event.target) : true
    if (outsideClick || !dropdownOpen) {
      setDropdownOpen(!dropdownOpen, () => {
        if (!dropdownOpen) {
          beginSelections()
        }
        if (dropdownOpen) {
          endSelections(true)
          clear()
        }
      })
    }
  }

  const _select = async (qElemNumber, qState) => {
    if (qState === 'S') {
      await select(Number(qElemNumber), true, ignoreLock)
    } else {
      await select(Number(qElemNumber), !single, ignoreLock)
      if (single) toggle()
    }
    if (afterSelect) {
      afterSelect()
    }
  }

  const handleSelect = selected => {
    if (qData.qMatrix.length === 1) {
      const { qElemNumber, qState } = qData.qMatrix[0][0]
      _select(qElemNumber, qState)
    } else {
      if (selected || valueList) {
        if (selected && selected.length > valueList.length) {
          const selection = xor(selected, valueList)
          const { qElemNumber, qState } = qData.qMatrix.filter(item => item[0].qElemNumber === selection[0].value)[0][0]
          _select(qElemNumber, qState)
        } else {
          const selection = xor(valueList, selected)
          const { qElemNumber, qState } = qData.qMatrix.filter(item => item[0].qElemNumber === selection[0].value)[0][0]
          _select(qElemNumber, qState)
        }
      }
    }

    setValueList(selected)
  }

  const _acceptListObjectSearch = () => {
    if (!single) acceptListObjectSearch(ignoreLock)
    if (single) _select(qData.qMatrix[0][0].qElemNumber, qData.qMatrix[0][0].qState)
    setValue('')
  }

  return (
    <div ref={node}>
      {qData && (
        <>
          <Select
            className={'basic-search'}
            classNamePrefix={'select'}
            isMulti
            value={value}
            isDisabled={false}
            isLoading={false}
            isClearable={true}
            isSearchable={true}
            onChange={selected => handleSelect(selected)}
            onInputChange={value => {
              return _searchListObjectFor({ target: { value } })
            }}
            options={
              qData &&
              qData.qMatrix.map(option => {
                return { label: option[0].qText, value: option[0].qElemNumber }
              })
            }
          />
        </>
      )}
    </div>
  )
}

QDocSearch.propTypes = {
  qDocPromise: PropTypes.object.isRequired,
  cols: PropTypes.array,
  qPage: PropTypes.object,
  single: PropTypes.bool,
  inverse: PropTypes.bool,
  placeholder: PropTypes.string,
  tooltipDock: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  tooltipContent: PropTypes.string,
  ignoreLock: PropTypes.bool,
  showGo: PropTypes.bool,
  afterSelect: PropTypes.func,
}

QDocSearch.defaultProps = {
  cols: null,
  single: false,
  inverse: false,
  placeholder: 'Search',
  tooltipDock: 'top',
  tooltipContent: null,
  ignoreLock: false,
  showGo: false,
  qPage: {
    qTop: 0,
    qLeft: 0,
    qWidth: 1,
    qHeight: 100,
  },
  afterSelect: null,
}

export default QDocSearch
